module.exports = __webpack_public_path__ + "img/Letemps-logo-new.7cdfdefa.svg";